import React, { ChangeEvent, memo } from "react";
import useAppFilterableSelect from "./index.hooks";
import { AppPaper, AppTextField } from "components/index";
import { Collapse, InputAdornment, MenuItem } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { FieldError } from "react-hook-form";

type AppFilterableSelectProps = {
  options: { label: string; value: string | number }[];
  inputClassName?: any;
  dropdownClassName?: any;
  paperClassName?: any;
  fullWidth?: boolean;
  searchValue?: string;
  onChange?: (ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onItemSelected?: (value: string | number) => void;
  className?: any;
  inputVariant?: "outlined" | "filled" | "standard";
  error?: FieldError;
  placeholder: string;
  disabled?: boolean;
};

const AppFilterableSelect = ({
  options,
  inputClassName,
  dropdownClassName,
  paperClassName,
  fullWidth,
  searchValue,
  onChange,
  onItemSelected,
  className,
  inputVariant,
  error,
  placeholder,
  disabled,
}: AppFilterableSelectProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    checked,
    handleCollapse,
    handleUncollapse,
  } = useAppFilterableSelect();

  return (
    <div className={className}>
      <AppTextField
        autoComplete={"off"}
        className={inputClassName}
        fullWidth={fullWidth ?? false}
        noHelper
        disabled={disabled ?? false}
        error={!!error}
        value={searchValue}
        onChange={onChange}
        onClick={handleUncollapse}
        onBlur={handleCollapse}
        placeholder={placeholder}
        variant={inputVariant ?? "outlined"}
        adornment={
          <>
            <InputAdornment position={"start"}>
              <SearchIcon />
            </InputAdornment>
          </>
        }
      />
      <Collapse
        in={checked}
        classes={classes.collapsedArea}
        className={dropdownClassName}
      >
        <AppPaper classes={classes.collapsedPaper} className={paperClassName}>
          {options.map((option) => {
            return (
              <MenuItem
                key={option.value}
                onClick={() => onItemSelected(option.value)}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </AppPaper>
      </Collapse>
    </div>
  );
};

export default memo(AppFilterableSelect);
